import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import AuthCallback from "@/components/AuthCallback";
import Seo from "@/components/Seo";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import FutureTeachers from "@/pages/FutureTeachers";
import InternationalTeachers from "@/pages/InternationalTeachers";
import CareerSupport from "@/pages/CareerSupport";
import MentorsSchools from "@/pages/MentorsSchools";
import Universities from "@/pages/Universities";
import Tutoring from "@/pages/Tutoring";
import TutorProfile from "@/pages/TutorProfile";
import Resources from "@/pages/Resources";
import WorkshopSeries from "@/pages/WorkshopSeries";
import AiWorkshops from "@/pages/AiWorkshops";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/future-teachers" element={<FutureTeachers />} />
        <Route path="/international-teachers" element={<InternationalTeachers />} />
        <Route path="/career-support" element={<CareerSupport />} />
        <Route path="/mentors-schools" element={<MentorsSchools />} />
        <Route path="/universities" element={<Universities />} />
        <Route path="/tutoring" element={<Tutoring />} />
        <Route path="/tutoring/:tutorId" element={<TutorProfile />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/workshop-series" element={<WorkshopSeries />} />
        <Route path="/ai-workshops" element={<AiWorkshops />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/account" element={<Account />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
        <BrowserRouter>
          <Seo />
          <AppRouter />
          <Toaster position="top-right" richColors offset="100px" />
        </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
